const DrugsData = [
    {
      id: 1,
      name: 'Paracetamol',
      company: 'ABC Pharmaceuticals',
      price: 25,
      uses: ['Pain reliever', 'Fever reducer'],
      ageGroups: ['Adults', 'Children'],
      strength: '500mg',
      expiryDate: '2025-12-30',
      tags: ['Pain relief', 'Fever', 'Headache'],
      seasonalUse: 'Winter',
      precautions: ['May cause liver damage in high doses', 'Avoid alcohol during use'],
      conditions: ['Liver disease', 'Kidney disease'],
      dosage: '1-2 tablets every 4-6 hours, not exceeding 8 tablets per day',
      links: [
        { name: 'Know More', url: 'https://www.abcpharma.com/paracetamol' },
      ],
      diseaseTypes: ['Pain', 'Fever', 'Headache']
    },
    {
      id: 2,
      name: 'Ibuprofen',
      company: 'XYZ Health Corp',
      price: 40,
      uses: ['Anti-inflammatory', 'Pain relief'],
      ageGroups: ['Adults'],
      strength: '200mg',
      expiryDate: '2026-03-15',
      tags: ['Arthritis', 'Pain management', 'Fever'],
      seasonalUse: 'Summer',
      precautions: ['Take with food to avoid stomach irritation', 'Avoid if allergic to aspirin'],
      conditions: ['Peptic ulcers', 'Asthma'],
      dosage: '1-2 tablets every 6-8 hours, not exceeding 6 tablets per day',
      links: [
        { name: 'Know More', url: 'https://www.xyzhealthcorp.com/ibuprofen' },
      ],
      diseaseTypes: ['Arthritis', 'Pain management', 'Fever']
    },
    {
      id: 3,
      name: 'Amoxicillin',
      company: 'Global Pharma',
      price: 100,
      uses: ['Antibiotic', 'Infection treatment'],
      ageGroups: ['Adults', 'Children'],
      strength: '500mg',
      expiryDate: '2024-11-01',
      tags: ['Antibiotic', 'Infection', 'Bacterial'],
      seasonalUse: 'Winter',
      precautions: ['Complete full course of treatment', 'May cause allergic reactions'],
      conditions: ['Allergic to penicillin', 'Kidney disease'],
      dosage: '250-500mg every 8 hours for 7-10 days',
      links: [
        { name: 'Know More', url: 'https://www.globalpharma.com/amoxicillin' },
      ],
      diseaseTypes: ['Bacterial infections', 'Ear infections', 'Respiratory infections']
    },
    {
      id: 4,
      name: 'Metformin',
      company: 'Diabetes Health',
      price: 60,
      uses: ['Diabetes management', 'Blood sugar control'],
      ageGroups: ['Adults'],
      strength: '850mg',
      expiryDate: '2027-01-10',
      tags: ['Diabetes', 'Blood sugar', 'Type 2 diabetes'],
      seasonalUse: 'All year round',
      precautions: ['Monitor blood sugar regularly', 'Avoid if you have severe kidney problems'],
      conditions: ['Kidney disease', 'Heart problems'],
      dosage: '500mg to 850mg once or twice a day with meals',
      links: [
        { name: 'Know More', url: 'https://www.diabeteshealth.com/metformin' },
      ],
      diseaseTypes: ['Type 2 diabetes', 'Blood sugar regulation']
    },
    {
      id: 5,
      name: 'Cetirizine',
      company: 'Allergy Care Ltd.',
      price: 20,
      uses: ['Allergy relief', 'Antihistamine'],
      ageGroups: ['Adults', 'Children'],
      strength: '10mg',
      expiryDate: '2024-06-20',
      tags: ['Allergy', 'Cold', 'Hay fever'],
      seasonalUse: 'Summer',
      precautions: ['May cause drowsiness', 'Avoid alcohol during use'],
      conditions: ['Liver or kidney problems', 'Pregnancy'],
      dosage: '1 tablet daily, preferably in the evening',
      links: [
        { name: 'Know More', url: 'https://www.allergycare.com/cetirizine' },
      ],
      diseaseTypes: ['Allergic rhinitis', 'Hay fever', 'Cold symptoms']
    },
    {
      id: 6,
      name: 'Fluoxetine',
      company: 'Mental Health Inc.',
      price: 120,
      uses: ['Depression treatment', 'Anxiety relief'],
      ageGroups: ['Adults', 'Teenagers'],
      strength: '20mg',
      expiryDate: '2025-11-22',
      tags: ['Depression', 'Anxiety', 'Mental health'],
      seasonalUse: 'All year round',
      precautions: ['May cause drowsiness or dizziness', 'Avoid alcohol'],
      conditions: ['Bipolar disorder', 'Pregnancy'],
      dosage: 'Start with 20mg daily, can increase after 1-2 weeks based on doctors advice',
      links: [
        { name: 'Know More', url: 'https://www.mentalhealthinc.com/fluoxetine' },
      ],
      diseaseTypes: ['Depression', 'Anxiety', 'Bipolar disorder']
    },
    {
      id: 7,
      name: 'Omeprazole',
      company: 'Gastro Care Pharmaceuticals',
      price: 75,
      uses: ['Acid reflux treatment', 'Stomach ulcers'],
      ageGroups: ['Adults'],
      strength: '20mg',
      expiryDate: '2026-07-15',
      tags: ['Acid reflux', 'Gastrointestinal', 'Ulcers'],
      seasonalUse: 'All year round',
      precautions: ['May interact with certain medications', 'Not suitable for pregnant women'],
      conditions: ['Gastroesophageal reflux disease (GERD)', 'Stomach ulcers'],
      dosage: '1 capsule daily before breakfast for 4-8 weeks',
      links: [
        { name: 'Know More', url: 'https://www.gastrocare.com/omeprazole' },
      ],
      diseaseTypes: ['Acid reflux', 'Gastrointestinal disorders']
    },
    {
      id: 8,
      name: 'Vitamin D3',
      company: 'Healthy Life Supplements',
      price: 150,
      uses: ['Bone health', 'Immune support'],
      ageGroups: ['Adults'],
      strength: '1000 IU',
      expiryDate: '2025-09-20',
      tags: ['Bone health', 'Vitamin D', 'Immune system'],
      seasonalUse: 'All year round',
      precautions: ['Overdose can cause hypercalcemia', 'Consult doctor before use if pregnant'],
      conditions: ['Osteoporosis', 'Vitamin D deficiency'],
      dosage: '1 tablet daily with food',
      links: [
        { name: 'Know More', url: 'https://www.healthylifesupplements.com/vitamin-d3' },
      ],
      diseaseTypes: ['Bone health', 'Immune system support']
    },
    {
      id: 9,
      name: 'Diphenhydramine',
      company: 'Sleep Aid Inc.',
      price: 30,
      uses: ['Sleep aid', 'Allergy relief'],
      ageGroups: ['Adults', 'Children'],
      strength: '25mg',
      expiryDate: '2026-05-30',
      tags: ['Sleep aid', 'Allergy relief', 'Antihistamine'],
      seasonalUse: 'All year round',
      precautions: ['May cause drowsiness', 'Avoid alcohol'],
      conditions: ['Insomnia', 'Allergic rhinitis'],
      dosage: '1 tablet 30 minutes before bedtime',
      links: [
        { name: 'Know More', url: 'https://www.sleepaidinc.com/diphenhydramine' },
      ],
      diseaseTypes: ['Insomnia', 'Allergic rhinitis']
    },
    {
      id: 10,
      name: 'Loratadine',
      company: 'Allergy Pharma',
      price: 50,
      uses: ['Allergy relief', 'Hay fever'],
      ageGroups: ['Adults', 'Children'],
      strength: '10mg',
      expiryDate: '2024-11-30',
      tags: ['Allergy', 'Hay fever', 'Antihistamine'],
      seasonalUse: 'Summer',
      precautions: ['Avoid alcohol', 'May cause drowsiness in some individuals'],
      conditions: ['Allergic rhinitis', 'Seasonal allergies'],
      dosage: '1 tablet daily',
      links: [
        { name: 'Know More', url: 'https://www.allergypharma.com/loratadine' },
      ],
      diseaseTypes: ['Allergic rhinitis', 'Hay fever', 'Seasonal allergies']
    },
    {
      id: 11,
      name: 'Levothyroxine',
      company: 'Thyroid Health Corp.',
      price: 100,
      uses: ['Thyroid hormone replacement'],
      ageGroups: ['Adults'],
      strength: '50mcg',
      expiryDate: '2025-08-18',
      tags: ['Thyroid', 'Hormone replacement', 'Endocrine'],
      seasonalUse: 'All year round',
      precautions: ['May interact with calcium and iron supplements', 'Monitor thyroid levels regularly'],
      conditions: ['Hypothyroidism'],
      dosage: 'Starting dose of 25-50mcg daily, adjusted based on thyroid function tests',
      links: [
        { name: 'Know More', url: 'https://www.thyroidhealth.com/levothyroxine' },
      ],
      diseaseTypes: ['Hypothyroidism', 'Thyroid disorders']
    },
    {
      id: 12,
      name: 'Simvastatin',
      company: 'CardioMed Solutions',
      price: 120,
      uses: ['Cholesterol management'],
      ageGroups: ['Adults'],
      strength: '20mg',
      expiryDate: '2026-02-10',
      tags: ['Cholesterol', 'Heart health', 'Lipid management'],
      seasonalUse: 'All year round',
      precautions: ['May interact with grapefruit', 'Liver function should be monitored'],
      conditions: ['Hyperlipidemia', 'Cardiovascular diseases'],
      dosage: '1 tablet at night',
      links: [
        { name: 'Know More', url: 'https://www.cardiosolutions.com/simvastatin' },
      ],
      diseaseTypes: ['High cholesterol', 'Heart health']
    },
    {
        id: 13,
        name: 'Amlodipine',
        company: 'Cardio Pharma',
        price: 80,
        uses: ['Hypertension', 'Angina'],
        ageGroups: ['Adults'],
        strength: '5mg',
        expiryDate: '2027-04-05',
        tags: ['Blood pressure', 'Heart disease', 'Angina'],
        seasonalUse: 'All year round',
        precautions: ['May cause dizziness or swelling of the ankles', 'Monitor blood pressure regularly'],
        conditions: ['Hypertension', 'Coronary artery disease'],
        dosage: '5mg once daily, can be increased to 10mg depending on response',
        links: [
          { name: 'Know More', url: 'https://www.cardio-pharma.com/amlodipine' },
        ],
        diseaseTypes: ['Hypertension', 'Angina', 'Cardiovascular disease']
      },
      {
        id: 14,
        name: 'Lisinopril',
        company: 'Heart Health Ltd.',
        price: 90,
        uses: ['High blood pressure', 'Heart failure'],
        ageGroups: ['Adults'],
        strength: '10mg',
        expiryDate: '2026-11-25',
        tags: ['Blood pressure', 'Heart failure', 'ACE inhibitor'],
        seasonalUse: 'All year round',
        precautions: ['May cause dizziness or a dry cough', 'Monitor kidney function regularly'],
        conditions: ['Hypertension', 'Chronic heart failure'],
        dosage: '10mg once daily, can be adjusted based on response',
        links: [
          { name: 'Know More', url: 'https://www.hearthealth.com/lisinopril' },
        ],
        diseaseTypes: ['Hypertension', 'Heart failure', 'Cardiovascular disease']
      },
      {
        id: 15,
        name: 'Hydrochlorothiazide',
        company: 'Renal Pharmaceuticals',
        price: 70,
        uses: ['Diuretic', 'Hypertension'],
        ageGroups: ['Adults'],
        strength: '25mg',
        expiryDate: '2025-03-10',
        tags: ['Diuretic', 'High blood pressure', 'Edema'],
        seasonalUse: 'All year round',
        precautions: ['May cause low potassium levels', 'Avoid prolonged sun exposure'],
        conditions: ['Hypertension', 'Edema'],
        dosage: '25-50mg once daily in the morning',
        links: [
          { name: 'Know More', url: 'https://www.renalpharma.com/hydrochlorothiazide' },
        ],
        diseaseTypes: ['Hypertension', 'Edema', 'Kidney disease']
      },
      {
        id: 16,
        name: 'Prednisone',
        company: 'ImmunoPharma',
        price: 100,
        uses: ['Inflammation', 'Autoimmune diseases'],
        ageGroups: ['Adults', 'Children'],
        strength: '10mg',
        expiryDate: '2025-12-15',
        tags: ['Steroid', 'Anti-inflammatory', 'Autoimmune'],
        seasonalUse: 'All year round',
        precautions: ['May cause weight gain or high blood sugar', 'Long-term use can affect bone health'],
        conditions: ['Rheumatoid arthritis', 'Asthma', 'Lupus'],
        dosage: '5-60mg daily depending on condition, taken with food',
        links: [
          { name: 'Know More', url: 'https://www.immunopharma.com/prednisone' },
        ],
        diseaseTypes: ['Autoimmune disorders', 'Inflammation', 'Asthma']
      },
      {
        id: 17,
        name: 'Tamsulosin',
        company: 'Urology Health',
        price: 85,
        uses: ['Benign prostatic hyperplasia', 'Urinary issues'],
        ageGroups: ['Adults'],
        strength: '0.4mg',
        expiryDate: '2026-09-10',
        tags: ['Prostate health', 'Urinary tract', 'Alpha-blocker'],
        seasonalUse: 'All year round',
        precautions: ['May cause dizziness or fainting', 'Take after the same meal every day'],
        conditions: ['Benign prostatic hyperplasia'],
        dosage: '0.4mg once daily, after breakfast',
        links: [
          { name: 'Know More', url: 'https://www.urologyhealth.com/tamsulosin' },
        ],
        diseaseTypes: ['Benign prostatic hyperplasia', 'Urinary problems']
      },
      {
        id: 18,
        name: 'Sertraline',
        company: 'Mental Health Meds',
        price: 130,
        uses: ['Depression', 'Anxiety'],
        ageGroups: ['Adults', 'Teenagers'],
        strength: '50mg',
        expiryDate: '2025-06-30',
        tags: ['Antidepressant', 'Anxiolytic', 'Mental health'],
        seasonalUse: 'All year round',
        precautions: ['May cause dizziness or dry mouth', 'Avoid alcohol during treatment'],
        conditions: ['Depression', 'Social anxiety disorder', 'Obsessive-compulsive disorder'],
        dosage: '50mg once daily, can increase up to 200mg per day depending on the response',
        links: [
          { name: 'Know More', url: 'https://www.mentalhealthmeds.com/sertraline' },
        ],
        diseaseTypes: ['Depression', 'Anxiety', 'OCD']
      },
      {
        id: 19,
        name: 'Alprazolam',
        company: 'CalmLife Pharma',
        price: 75,
        uses: ['Anxiety relief', 'Panic attacks'],
        ageGroups: ['Adults'],
        strength: '0.5mg',
        expiryDate: '2025-05-10',
        tags: ['Anxiolytic', 'Panic attacks', 'Sedative'],
        seasonalUse: 'All year round',
        precautions: ['May cause drowsiness or dizziness', 'Not recommended for long-term use'],
        conditions: ['Generalized anxiety disorder', 'Panic disorder'],
        dosage: '0.5-1mg once to twice daily, not exceeding 4mg per day',
        links: [
          { name: 'Know More', url: 'https://www.calmlifepharma.com/alprazolam' },
        ],
        diseaseTypes: ['Anxiety', 'Panic attacks']
      },
      {
        id: 20,
        name: 'Clopidogrel',
        company: 'Cardio Pharma',
        price: 95,
        uses: ['Antiplatelet', 'Stroke prevention'],
        ageGroups: ['Adults'],
        strength: '75mg',
        expiryDate: '2026-08-15',
        tags: ['Stroke prevention', 'Heart disease', 'Blood thinner'],
        seasonalUse: 'All year round',
        precautions: ['May cause bleeding or bruising', 'Monitor for any unusual bleeding'],
        conditions: ['Coronary artery disease', 'Stroke prevention'],
        dosage: '75mg once daily',
        links: [
          { name: 'Know More', url: 'https://www.cardiopharma.com/clopidogrel' },
        ],
        diseaseTypes: ['Stroke prevention', 'Heart disease', 'Blood clotting disorders']
      },
      {
        id: 21,
        name: 'Levocetirizine',
        company: 'Allergy Relief Inc.',
        price: 45,
        uses: ['Allergy relief', 'Antihistamine'],
        ageGroups: ['Adults', 'Children'],
        strength: '5mg',
        expiryDate: '2025-04-01',
        tags: ['Allergy', 'Antihistamine', 'Cold'],
        seasonalUse: 'Spring, Summer, Fall',
        precautions: ['May cause drowsiness', 'Avoid alcohol during use'],
        conditions: ['Hay fever', 'Allergic rhinitis'],
        dosage: '1 tablet daily in the evening',
        links: [
          { name: 'Know More', url: 'https://www.allergyrelief.com/levocetirizine' },
        ],
        diseaseTypes: ['Allergic rhinitis', 'Hay fever']
      },
      {
        id: 22,
        name: 'Gabapentin',
        company: 'Neurology Health',
        price: 110,
        uses: ['Neuropathic pain', 'Seizure management'],
        ageGroups: ['Adults'],
        strength: '300mg',
        expiryDate: '2025-10-22',
        tags: ['Neuropathy', 'Seizures', 'Pain management'],
        seasonalUse: 'All year round',
        precautions: ['May cause dizziness or sleepiness', 'Gradual dose tapering required'],
        conditions: ['Neuropathic pain', 'Epilepsy'],
        dosage: '300-1200mg per day depending on condition',
        links: [
          { name: 'Know More', url: 'https://www.neurologyhealth.com/gabapentin' },
        ],
        diseaseTypes: ['Neuropathic pain', 'Seizure disorders']
      },
      {
        id: 23,
        name: 'Losartan',
        company: 'Cardio Pharma',
        price: 85,
        uses: ['Hypertension', 'Chronic kidney disease'],
        ageGroups: ['Adults'],
        strength: '50mg',
        expiryDate: '2026-12-10',
        tags: ['Blood pressure', 'Kidney disease', 'Angiotensin II receptor blocker'],
        seasonalUse: 'All year round',
        precautions: ['Monitor kidney function and blood pressure regularly', 'May cause dizziness'],
        conditions: ['Hypertension', 'Chronic kidney disease'],
        dosage: '50mg once daily, may increase to 100mg daily if needed',
        links: [
          { name: 'Know More', url: 'https://www.cardio-pharma.com/losartan' },
        ],
        diseaseTypes: ['Hypertension', 'Chronic kidney disease']
      },
      {
        id: 24,
        name: 'Sildenafil',
        company: 'Health Care Pharmaceuticals',
        price: 150,
        uses: ['Erectile dysfunction', 'Pulmonary hypertension'],
        ageGroups: ['Adults'],
        strength: '50mg',
        expiryDate: '2027-02-01',
        tags: ['Erectile dysfunction', 'Pulmonary hypertension', 'Vasodilator'],
        seasonalUse: 'All year round',
        precautions: ['May cause headaches or dizziness', 'Avoid taking with nitrates'],
        conditions: ['Erectile dysfunction', 'Pulmonary arterial hypertension'],
        dosage: '50mg taken 30 minutes to 1 hour before sexual activity, not exceeding one dose per day',
        links: [
          { name: 'Know More', url: 'https://www.healthcarepharma.com/sildenafil' },
        ],
        diseaseTypes: ['Erectile dysfunction', 'Pulmonary hypertension']
      },
      {
        id: 25,
        name: 'Levothyroxine',
        company: 'Thyroid Care Ltd.',
        price: 95,
        uses: ['Hypothyroidism', 'Thyroid hormone replacement'],
        ageGroups: ['Adults'],
        strength: '50mcg',
        expiryDate: '2026-06-20',
        tags: ['Thyroid', 'Hypothyroidism', 'Hormone replacement'],
        seasonalUse: 'All year round',
        precautions: ['May interact with certain foods and medications', 'Monitor thyroid levels regularly'],
        conditions: ['Hypothyroidism'],
        dosage: 'Start with 25-50mcg daily, adjusting based on thyroid hormone levels',
        links: [
          { name: 'Know More', url: 'https://www.thyroidcare.com/levothyroxine' },
        ],
        diseaseTypes: ['Hypothyroidism', 'Thyroid disorders']
      },
      {
        id: 26,
        name: 'Azithromycin',
        company: 'Global Pharma Solutions',
        price: 120,
        uses: ['Bacterial infections', 'Antibiotic'],
        ageGroups: ['Adults', 'Children'],
        strength: '500mg',
        expiryDate: '2025-07-25',
        tags: ['Antibiotic', 'Bacterial infections', 'Respiratory infections'],
        seasonalUse: 'All year round',
        precautions: ['Complete the full course', 'May cause gastrointestinal upset'],
        conditions: ['Bacterial infections', 'Respiratory infections'],
        dosage: '500mg once daily for 3-5 days, depending on infection severity',
        links: [
          { name: 'Know More', url: 'https://www.globalpharmasolutions.com/azithromycin' },
        ],
        diseaseTypes: ['Respiratory infections', 'Bacterial infections', 'Ear infections']
      },
      {
        id: 27,
        name: 'Methotrexate',
        company: 'ImmunoMed',
        price: 160,
        uses: ['Cancer treatment', 'Rheumatoid arthritis'],
        ageGroups: ['Adults'],
        strength: '2.5mg',
        expiryDate: '2026-01-05',
        tags: ['Cancer', 'Rheumatoid arthritis', 'Immunosuppressive'],
        seasonalUse: 'All year round',
        precautions: ['May cause nausea, liver damage, or bone marrow suppression', 'Regular blood tests required'],
        conditions: ['Rheumatoid arthritis', 'Certain types of cancer'],
        dosage: '7.5-25mg per week, taken orally or by injection',
        links: [
          { name: 'Know More', url: 'https://www.immunomed.com/methotrexate' },
        ],
        diseaseTypes: ['Cancer', 'Rheumatoid arthritis', 'Autoimmune diseases']
      },
      {
        id: 28,
        name: 'Furosemide',
        company: 'Renal Solutions',
        price: 60,
        uses: ['Edema', 'Hypertension'],
        ageGroups: ['Adults'],
        strength: '40mg',
        expiryDate: '2025-10-15',
        tags: ['Diuretic', 'Hypertension', 'Edema'],
        seasonalUse: 'All year round',
        precautions: ['May cause dehydration and low potassium levels', 'Monitor kidney function regularly'],
        conditions: ['Edema', 'Hypertension'],
        dosage: '20-80mg per day depending on the condition',
        links: [
          { name: 'Know More', url: 'https://www.renal-solutions.com/furosemide' },
        ],
        diseaseTypes: ['Hypertension', 'Edema', 'Kidney diseases']
      },
      {
        id: 29,
        name: 'Ciprofloxacin',
        company: 'PharmaTech',
        price: 110,
        uses: ['Antibiotic', 'Bacterial infections'],
        ageGroups: ['Adults', 'Children'],
        strength: '500mg',
        expiryDate: '2025-03-30',
        tags: ['Antibiotic', 'Infection', 'Urinary tract infections'],
        seasonalUse: 'All year round',
        precautions: ['May cause tendonitis or tendon rupture', 'Avoid prolonged exposure to sunlight'],
        conditions: ['Bacterial infections', 'Urinary tract infections'],
        dosage: '500mg twice daily for 7-14 days depending on infection type',
        links: [
          { name: 'Know More', url: 'https://www.pharmatech.com/ciprofloxacin' },
        ],
        diseaseTypes: ['Bacterial infections', 'Urinary tract infections']
      },
      {
        id: 30,
        name: 'Duloxetine',
        company: 'Mental Wellness Ltd.',
        price: 130,
        uses: ['Depression', 'Anxiety', 'Neuropathic pain'],
        ageGroups: ['Adults'],
        strength: '60mg',
        expiryDate: '2025-12-15',
        tags: ['Antidepressant', 'Pain management', 'Mental health'],
        seasonalUse: 'All year round',
        precautions: ['May increase blood pressure', 'Avoid alcohol during treatment'],
        conditions: ['Depression', 'Generalized anxiety disorder', 'Neuropathic pain'],
        dosage: '30-60mg once daily, may increase based on response',
        links: [
          { name: 'Know More', url: 'https://www.mentalwellness.com/duloxetine' },
        ],
        diseaseTypes: ['Depression', 'Anxiety', 'Pain management']
      }, {
        id: 31,
        name: 'Diphenhydramine',
        company: 'Allergy Solutions Inc.',
        price: 45,
        uses: ['Cold symptoms', 'Allergy relief', 'Sleep aid'],
        ageGroups: ['Adults', 'Children'],
        strength: '25mg',
        expiryDate: '2025-08-15',
        tags: ['Cold relief', 'Allergy', 'Sleep aid'],
        seasonalUse: 'Winter',
        precautions: ['May cause drowsiness', 'Avoid alcohol'],
        conditions: ['Seasonal allergies', 'Insomnia', 'Cold symptoms'],
        dosage: '25-50mg every 4-6 hours, not exceeding 300mg per day',
        links: [
          { name: 'Know More', url: 'https://www.allergysolutions.com/diphenhydramine' },
        ],
        diseaseTypes: ['Cold symptoms', 'Allergic rhinitis', 'Sleep disorders']
      },
      {
        id: 32,
        name: 'Mometasone',
        company: 'Respiratory Health Co.',
        price: 120,
        uses: ['Nasal allergy relief', 'Sinus congestion'],
        ageGroups: ['Adults', 'Children'],
        strength: '50mcg',
        expiryDate: '2026-02-10',
        tags: ['Allergy relief', 'Nasal congestion', 'Sinusitis'],
        seasonalUse: 'Winter',
        precautions: ['May cause nasal irritation', 'Avoid prolonged use'],
        conditions: ['Allergic rhinitis', 'Sinusitis'],
        dosage: '1-2 sprays in each nostril once daily',
        links: [
          { name: 'Know More', url: 'https://www.respiratoryhealthco.com/mometasone' },
        ],
        diseaseTypes: ['Allergic rhinitis', 'Sinus congestion', 'Sinusitis']
      },
      {
        id: 33,
        name: 'Pseudoephedrine',
        company: 'Cold Care Pharm',
        price: 30,
        uses: ['Decongestant', 'Relieves sinus pressure'],
        ageGroups: ['Adults'],
        strength: '60mg',
        expiryDate: '2025-12-05',
        tags: ['Cold relief', 'Sinus pressure', 'Decongestant'],
        seasonalUse: 'Winter',
        precautions: ['May cause nervousness or insomnia', 'Avoid use if you have high blood pressure'],
        conditions: ['Sinus congestion', 'Cold symptoms'],
        dosage: '60mg every 4-6 hours, not exceeding 240mg per day',
        links: [
          { name: 'Know More', url: 'https://www.coldcarepharm.com/pseudoephedrine' },
        ],
        diseaseTypes: ['Cold symptoms', 'Sinus congestion']
      },
      {
        id: 34,
        name: 'Chlorpheniramine',
        company: 'Allergy Relief Co.',
        price: 25,
        uses: ['Cold symptoms', 'Allergy relief', 'Cough suppressant'],
        ageGroups: ['Adults', 'Children'],
        strength: '4mg',
        expiryDate: '2024-11-18',
        tags: ['Cold relief', 'Allergy', 'Cough suppressant'],
        seasonalUse: 'Winter',
        precautions: ['May cause drowsiness', 'Avoid alcohol'],
        conditions: ['Cold symptoms', 'Seasonal allergies'],
        dosage: '1 tablet every 4-6 hours, not exceeding 12 tablets per day',
        links: [
          { name: 'Know More', url: 'https://www.allergyreliefco.com/chlorpheniramine' },
        ],
        diseaseTypes: ['Cold symptoms', 'Allergic rhinitis', 'Cough']
      },
      {
        id: 35,
        name: 'Oseltamivir',
        company: 'Viral Health Inc.',
        price: 250,
        uses: ['Flu treatment', 'Antiviral'],
        ageGroups: ['Adults', 'Children'],
        strength: '75mg',
        expiryDate: '2026-04-30',
        tags: ['Flu', 'Antiviral', 'Influenza'],
        seasonalUse: 'Winter',
        precautions: ['May cause nausea or vomiting', 'Not a substitute for flu vaccination'],
        conditions: ['Influenza', 'Seasonal flu'],
        dosage: '75mg twice daily for 5 days',
        links: [
          { name: 'Know More', url: 'https://www.viralhealthinc.com/oseltamivir' },
        ],
        diseaseTypes: ['Flu', 'Influenza']
      },
      {
        id: 36,
        name: 'Guaifenesin',
        company: 'Respiratory Pharma',
        price: 40,
        uses: ['Expectorant', 'Cough relief'],
        ageGroups: ['Adults', 'Children'],
        strength: '200mg',
        expiryDate: '2025-05-20',
        tags: ['Cough relief', 'Expectorant', 'Cold symptoms'],
        seasonalUse: 'Winter',
        precautions: ['May cause nausea or dizziness', 'Stay hydrated while using'],
        conditions: ['Cough', 'Cold symptoms', 'Chest congestion'],
        dosage: '200mg every 4 hours, not exceeding 1200mg per day',
        links: [
          { name: 'Know More', url: 'https://www.respiratorypharma.com/guaifenesin' },
        ],
        diseaseTypes: ['Cough', 'Cold symptoms', 'Chest congestion']
      },
      {
        id: 37,
        name: 'Vitamin C',
        company: 'Immunity Health',
        price: 35,
        uses: ['Immune support', 'Cold prevention'],
        ageGroups: ['Adults', 'Children'],
        strength: '500mg',
        expiryDate: '2025-10-12',
        tags: ['Immune support', 'Cold prevention', 'Winter wellness'],
        seasonalUse: 'Winter',
        precautions: ['May cause stomach upset in high doses', 'Consult a doctor for high doses'],
        conditions: ['Cold prevention', 'Immune health'],
        dosage: '500mg once daily, can increase during illness',
        links: [
          { name: 'Know More', url: 'https://www.immunityhealth.com/vitamin-c' },
        ],
        diseaseTypes: ['Cold prevention', 'Immune support']
      },
      {
        id: 38,
        name: 'Zinc Supplement',
        company: 'Cold Defense Labs',
        price: 50,
        uses: ['Immune support', 'Cold treatment'],
        ageGroups: ['Adults'],
        strength: '10mg',
        expiryDate: '2026-09-20',
        tags: ['Immune support', 'Cold treatment', 'Zinc'],
        seasonalUse: 'Winter',
        precautions: ['Do not exceed recommended dose', 'May cause nausea if taken on an empty stomach'],
        conditions: ['Cold prevention', 'Immune health'],
        dosage: '10mg once daily, may increase during illness as advised by a doctor',
        links: [
          { name: 'Know More', url: 'https://www.colddefenselabs.com/zinc-supplement' },
        ],
        diseaseTypes: ['Cold prevention', 'Immune support']
      },
      {
        id: 39,
        name: 'Hydrocodone',
        company: 'Pain Relief Corp.',
        price: 200,
        uses: ['Severe cough', 'Pain relief'],
        ageGroups: ['Adults'],
        strength: '10mg',
        expiryDate: '2025-01-25',
        tags: ['Cough suppressant', 'Pain relief', 'Opioid'],
        seasonalUse: 'Winter',
        precautions: ['Risk of addiction', 'May cause drowsiness', 'Do not use with alcohol'],
        conditions: ['Severe cough', 'Chronic pain'],
        dosage: '10mg every 4-6 hours, not exceeding 60mg per day',
        links: [
          { name: 'Know More', url: 'https://www.painreliefcorp.com/hydrocodone' },
        ],
        diseaseTypes: ['Cough suppressant', 'Pain relief']
      },
      {
        id: 40,
        name: 'Levocetirizine',
        company: 'Allergy Relief Ltd.',
        price: 60,
        uses: ['Allergy relief', 'Cold symptoms'],
        ageGroups: ['Adults', 'Children'],
        strength: '5mg',
        expiryDate: '2025-04-30',
        tags: ['Allergy relief', 'Cold symptoms', 'Hay fever'],
        seasonalUse: 'Winter',
        precautions: ['May cause drowsiness', 'Avoid alcohol'],
        conditions: ['Seasonal allergies', 'Cold symptoms'],
        dosage: '5mg once daily, preferably in the evening',
        links: [
          { name: 'Know More', url: 'https://www.allergyreliefltd.com/levocetirizine' },
        ],
        diseaseTypes: ['Allergic rhinitis', 'Cold symptoms', 'Hay fever']
      }

  ];
  
  export default DrugsData;
  